export enum LedgerType {
  'Type1' = 0,
  'Type2' = 1,
}
